import styled from "styled-components";

export const ChangeWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const ChangePassContainer = styled.div`
  background-color: ${(props) => props.theme.backgroundColor};
  width: 365px;
  max-width: 365px;
  padding: 24px;
  border-radius: 5px;
`;

export const ChangePassInputs = styled.form``;

export const HeaderCreditModal = styled.div`
  display: flex;
  justify-content: space-between;
  p {
    margin-bottom: 24px;
  }
  span {
    font-size: 1.3rem;
    cursor: pointer;
    user-select: none;
  }
`;
